var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryActiveSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72314 14.96V20.9466C4.72314 26.9333 7.12314 29.3333 13.1098 29.3333H20.2965C26.2831 29.3333 28.6831 26.9333 28.6831 20.9466V14.96",
    stroke: "#F5EBF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7099 16C19.1499 16 20.9499 14.0133 20.7099 11.5733L19.8299 2.66667H13.6033L12.7099 11.5733C12.4699 14.0133 14.2699 16 16.7099 16Z",
    stroke: "#F5EBF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1235 16C27.8169 16 29.7902 13.8133 29.5235 11.1333L29.1502 7.46667C28.6702 4.00001 27.3369 2.66667 23.8435 2.66667H19.7769L20.7102 12.0133C20.9369 14.2133 22.9235 16 25.1235 16Z",
    stroke: "#F5EBF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2298 16C10.4298 16 12.4165 14.2133 12.6298 12.0133L12.9231 9.06667L13.5631 2.66667H9.49647C6.00314 2.66667 4.6698 4.00001 4.1898 7.46667L3.8298 11.1333C3.56314 13.8133 5.53647 16 8.2298 16Z",
    stroke: "#F5EBF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7098 22.6667C14.4831 22.6667 13.3765 23.7733 13.3765 26V29.3333H20.0431V26C20.0431 23.7733 18.9365 22.6667 16.7098 22.6667Z",
    stroke: "#F5EBF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryActiveSvg);
export default __webpack_public_path__ + "static/media/categoryActiveSvg.850e5115cefb3baecb08b7f292127391.svg";
export { ForwardRef as ReactComponent };